/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Booking'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019.2020  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomeBooking from '../../../components/booking/Home.vue'; // 'Home-Booking' ..
import Passengers from '../../../components/booking/passengers/Passengers.vue'; // 'Paxes&Service's ..
import Payment from '../../../components/booking/payment/Payment.vue'; // 'Payment' ..
import Overview from '../../../components/booking/overview/Overview.vue'; // 'Overview' ..
import Confirmation from '../../../components/booking/confirmation/Confirmation.vue'; // 'Confirmation' ..


export const routesbooking = [
    { path: '', component: HomeBooking },
    // { path: '', component: FlightSearchResultsBooking }, // Step: 1
    // { path: '/passengers', name: 'Passengers', component: Passengers }, // Step: 2
    { path: '/passengers/:modulo?', name: 'Passengers', component: Passengers, props: true }, // Step: 2
    { path: '/payment/:modulo?', name: 'Payment', component: Payment, props: true }, // Step: 3
    { path: '/overview/:modulo?', name: 'Overview', component: Overview, props: true }, // Step: 4
    { path: '/confirmation/:modulo?', name: 'Confirmation', component: Confirmation, props: true }, // Step: 5
];
